import React, { useState } from 'react';
import { contactsAPI } from '../../lib/supabase';
import './ContactForm.css';

const ContactForm = ({ title = "Quick Inquiry", showSubject = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    inquiryType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Prepare data for Supabase
      const contactData = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim() || null,
        inquiry_type: formData.inquiryType,
        subject: showSubject ? formData.subject.trim() : null,
        message: formData.message.trim(),
        status: 'new'
      };

      // Insert data into Supabase
      const result = await contactsAPI.create(contactData);
      
      console.log('Contact form submitted successfully:', result);
      setSubmitStatus('success');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        inquiryType: '',
        message: ''
      });

    } catch (error) {
      console.error('Error submitting contact form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form">
      <h3 className="form-title">{title}</h3>
      
      {submitStatus === 'success' && (
        <div className="form-message success">
          <i className="fas fa-check-circle"></i>
          Thank you for your message! We'll get back to you soon.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="form-message error">
          <i className="fas fa-exclamation-circle"></i>
          Sorry, there was an error sending your message. Please try again.
        </div>
      )}

      <form onSubmit={handleSubmit} className="form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name" className="form-label">
              Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              required
              placeholder="Your full name"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
              placeholder="your.email@example.com"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone" className="form-label">
              Phone
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-input"
              placeholder="+1 (234) 567-8900"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="inquiryType" className="form-label">
              Inquiry Type *
            </label>
            <select
              id="inquiryType"
              name="inquiryType"
              value={formData.inquiryType}
              onChange={handleChange}
              className="form-input form-select"
              required
            >
              <option value="">Select inquiry type</option>
              <option value="Residential project">Residential project</option>
              <option value="Industrial project">Industrial project</option>
              <option value="Services">Services</option>
              <option value="Career">Career</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>

        {showSubject && (
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="subject" className="form-label">
                Subject *
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="form-input"
                required={showSubject}
                placeholder="What's this about?"
              />
            </div>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="message" className="form-label">
            Message *
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="form-input form-textarea"
            required
            rows="5"
            placeholder="Tell us about your project or inquiry..."
          ></textarea>
        </div>

        <button
          type="submit"
          className={`btn btn-primary form-submit ${isSubmitting ? 'submitting' : ''}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="spinner"></span>
              Sending...
            </>
          ) : (
            <>
              Send Message
              <i className="fas fa-paper-plane"></i>
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;